/**
 * Items catalog — soft amber / orange accent (light theme)
 */
export const ITEMS_THEME = {
  title: 'Items catalog',
  subtitle: 'Products and services for sales, purchases, and stock',
  historyTitle: 'All items',
  searchPlaceholder: 'Search name, HSN, unit, category…',

  pageBg: 'bg-slate-50',
  header: 'from-amber-50/90 via-white to-orange-50/70',
  headerAccentLine: 'h-px bg-amber-100/80',
  cardBorder: 'border-slate-200/60',
  cardShadow: 'shadow-sm',
  iconTile: 'bg-gradient-to-br from-amber-400 to-orange-300 shadow-sm',
  iconAccent: 'text-amber-600',

  subNavActive: 'bg-white text-amber-800 shadow-sm ring-1 ring-amber-100',
  subNavIdle: 'text-slate-600 hover:text-amber-900 hover:bg-white/80',
  subNavIdleBg: 'bg-amber-50/40',

  statPill: 'rounded-lg bg-white/90 border border-amber-100/70 px-2.5 py-1 text-[11px] text-slate-600',
  statPillStrong: 'font-bold text-amber-800 tabular-nums',

  stat: 'text-amber-700',
  fieldFocus: 'focus:border-amber-400 focus:outline-none focus:ring-2 focus:ring-amber-400/15',
  filterFocus: 'focus:border-amber-400 focus:ring-amber-400/15',
  filterIcon: 'text-amber-500',
  stripe: 'bg-amber-400',
  stripeAlt: 'bg-orange-300',
  btn: 'from-amber-500 to-orange-400 hover:from-amber-600 hover:to-orange-500',
  btnRing: 'focus:ring-amber-400',
  btnSecondary:
    'text-slate-700 border-slate-200 hover:bg-slate-50 hover:border-slate-300',
  amount: 'text-amber-800',
  amountBg: 'bg-amber-50/80 text-amber-800 ring-1 ring-amber-100/80',
  hoverRow: 'hover:bg-amber-50/30',
  groupRow: 'bg-amber-50/40 text-slate-800',
  groupSub: 'text-amber-700',
  dropdownHover: 'hover:bg-amber-50/60',
  emptyIcon: 'text-amber-200',
  emptyBg: 'bg-amber-50/40',
  mobileFilterActive: 'bg-amber-50/80 border-amber-100 text-amber-800',
  mobileFilterBadge: 'bg-amber-500',
  editIcon: 'text-amber-700 bg-amber-50/80 hover:bg-amber-100/80',
  sectionHeadBg: 'from-amber-50/80 to-white',
  sectionHeadBorder: 'border-amber-100/70',
  sectionHeadText: 'text-amber-800/90',
  sectionWrap: 'rounded-xl border border-amber-100/50 bg-amber-50/15 p-3',
  filtersHeadBg: 'bg-amber-50/40',
  filtersHeadBorder: 'border-amber-100/70',
  filtersHeadText: 'text-amber-800/75',
  statLabel: 'text-slate-500',
  statCard: 'rounded-xl border border-amber-100/50 bg-white px-3 py-2 shadow-sm',
  avatarGradient: 'from-amber-400 to-orange-300',
  subtitleOnHeader: 'text-slate-500',
  checkbox: 'text-amber-500 focus:ring-amber-400',
  importLink:
    'inline-flex items-center gap-1 px-2.5 py-1 text-xs font-medium text-amber-800 bg-white border border-amber-100 rounded-lg hover:bg-amber-50/60',
  importLinkLg:
    'inline-flex items-center gap-2 px-3 py-2 text-sm font-medium text-amber-800 border border-amber-100 rounded-lg hover:bg-amber-50/60',
  filtersAreaBg: 'bg-amber-50/20',
  filterActiveText: 'text-amber-700',
  tableHead: 'bg-amber-50/60 text-amber-800/75',
  tableHeadSticky: 'bg-amber-50/80 sticky top-0 z-10 shadow-sm',
  sortTh: 'px-3 py-2.5 align-middle cursor-pointer hover:text-amber-800 text-inherit',
  sortActive: 'text-amber-600 font-semibold',
  formPanelBg: 'bg-slate-50/30',
  formHeader: 'bg-amber-50/50 border-amber-100/70',
  formTitle: 'text-slate-900',
  detailsBorder: 'border-slate-200/70',
  zebra: 'bg-amber-50/10',
  divider: 'divide-slate-200/70',

  panelHeader:
    'p-4 border-b border-amber-100/70 bg-gradient-to-r from-amber-50/90 via-white to-orange-50/60',
  listPanelHeader:
    'px-4 py-3 border-b border-amber-100/70 bg-gradient-to-r from-amber-50/80 via-white to-orange-50/50',
  contentCard: 'bg-white rounded-xl shadow-sm overflow-hidden border border-slate-200/50',

  statCardTotal: 'bg-white rounded-xl border border-slate-200/70 p-4 shadow-sm',
  statCardActive: 'bg-gradient-to-br from-emerald-50/80 to-amber-50/60 rounded-xl border border-emerald-100/60 p-4 shadow-sm',
  statCardInactive: 'bg-gradient-to-br from-slate-50 to-gray-50/80 rounded-xl border border-slate-200/60 p-4 shadow-sm',
  statCardFiltered: 'bg-gradient-to-br from-amber-50/80 to-orange-50/50 rounded-xl border border-amber-100/60 p-4 shadow-sm',
};

export const btnPrimarySm =
  'inline-flex items-center justify-center gap-1 px-2.5 py-1.5 text-xs font-semibold text-white bg-amber-500 rounded-lg hover:bg-amber-600 transition-colors shadow-sm';
export const btnSecondarySm =
  'inline-flex items-center justify-center gap-1 px-2.5 py-1.5 text-xs font-semibold text-amber-800 bg-amber-50/80 rounded-lg hover:bg-amber-100/80 transition-colors';

export const fieldBase =
  'w-full rounded-lg border border-slate-200 bg-white px-2.5 py-1.5 text-sm text-gray-900';
export const formLabelCls = 'mb-0.5 block text-xs font-medium text-slate-600';
export const formFieldCls = fieldBase;

export function itemTypeBadgeClass(type) {
  switch (type) {
    case 'Goods':
      return 'bg-amber-50/80 text-amber-800 ring-amber-100/80';
    case 'Services':
      return 'bg-orange-50/80 text-orange-800 ring-orange-100/80';
    case 'Restaurant':
      return 'bg-yellow-50/80 text-yellow-800 ring-yellow-100/80';
    default:
      return 'bg-slate-50 text-slate-600 ring-slate-100';
  }
}
